"use client"

import { PageMaxWidth } from "@/components"
import { Button, IconButton, Text } from "@/elements"
import { ArrowLeftIcon } from "@heroicons/react/24/outline"

interface Props {
  includeBack?: boolean
  backOnClick: () => void
  progressBarPercentage?: string
  onExit?: () => void
  mutating?: boolean
  title?: string
  exitText?: string
}

export const WizardNav: React.FC<Props> = ({
  includeBack = true,
  backOnClick,
  onExit,
  progressBarPercentage,
  mutating,
  exitText = "Exit",
  title = "",
}) => {
  return (
    <div className="relative mx-auto h-[73px] border-b border-bg-3 bg-bg-1">
      <PageMaxWidth>
        <div className="flex flex-row items-center justify-between px-5 py-4">
          <div className="flex-1">
            {includeBack ? (
              <>
                <Button variant="transparent" className="hidden sm:block" onClick={backOnClick}>
                  Back
                </Button>
                <IconButton variant="white" className="block sm:hidden" onClick={backOnClick} Icon={ArrowLeftIcon} />
              </>
            ) : null}
          </div>

          {progressBarPercentage ? (
            <div className="relative hidden h-[3px] w-full max-w-[420px] flex-1 rounded-full bg-bg-3 sm:block">
              <div
                className="absolute left-0 top-0 h-full rounded-full bg-primary-3 transition-all duration-300"
                style={{ width: `${progressBarPercentage}` }}
              />
            </div>
          ) : (
            <Text variant="CTASmall" className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
              {title}
            </Text>
          )}

          {onExit ? (
            <div className="flex flex-1 justify-end">
              <Button variant="transparent" loading={mutating} onClick={onExit}>
                {/* Save and Exit */}
                {exitText}
              </Button>
            </div>
          ) : null}
        </div>
      </PageMaxWidth>
    </div>
  )
}
